<template>
  <div class="doge-shell">
    <header class="doge-top"><button class="doge-back" @click="$router.back()">‹</button><h1 class="doge-title">联系我们</h1><div class="doge-placeholder"></div></header>
    <main class="doge-page-pad">
      <section class="contact-hero"><div class="doge-token big">Ð</div><h2>DOGECOIN</h2><p>官方客服与社区联系方式</p></section>
      <section class="doge-card">
        <div v-if="loading" class="doge-empty">加载中...</div>
        <div v-for="item in contacts" :key="item.platform" class="contact-row">
          <div><span>{{ item.platform }}</span><b>{{ item.value }}</b></div>
          <button class="doge-copy" @click="copy(item.value)">复制</button>
        </div>
        <div v-if="!loading && !contacts.length" class="doge-empty">暂无联系方式</div>
      </section>
    </main>
    <BottomNav/>
  </div>
</template>
<script>
import BottomNav from '../../components/layout/BottomNav.vue';
export default {
  name: 'aboutUs',
  components: { BottomNav },
  data() { return { contacts: [], loading: false }; },
  mounted() { this.load(); },
  methods: {
    async load() {
      this.loading = true;
      try {
        const keys = [
          { key: 'contact_email', platform: 'Email' },
          { key: 'contact_mobile', platform: 'Phone' },
          { key: 'contact_telegram', platform: 'Telegram' }
        ];
        const results = await Promise.all(keys.map(item => this.$axios.get('/api/default/setting', { key: item.key }).then(r => ({ ...item, value: r.data.data })).catch(() => ({ ...item, value: '' }))));
        const email = results.find(item => item.key === 'contact_email');
        if (email && !email.value) email.value = 'dogecoinmdao@gmail.com';
        this.contacts = results.filter(item => item.value);
      } catch (e) {
        this.contacts = [];
      } finally {
        this.loading = false;
      }
    },
    copy(t) { if (!t) return; navigator.clipboard && navigator.clipboard.writeText(t); this.$messageDialog ? this.$messageDialog.alert('复制成功', '提示', 'success') : alert('复制成功'); }
  }
};
</script>
<style scoped>.contact-hero{border-radius:22px;background:linear-gradient(160deg,#2d1904,#d59727);padding:28px;text-align:center;margin-bottom:16px}.doge-token.big{width:84px;height:84px;font-size:54px;margin:0 auto 12px}.contact-hero h2{margin:0;color:#fff}.contact-hero p{color:#ffe3ad}.contact-row{display:flex;justify-content:space-between;align-items:center;gap:12px;border-bottom:1px solid var(--doge-line);padding:15px 0}.contact-row:last-child{border-bottom:0}.contact-row span{display:block;color:var(--doge-muted);margin-bottom:5px}.contact-row b{font-size:14px;word-break:break-all}</style>
